import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const scimSettingsStyles = {

    secretButton: style({
        marginTop: TabStyles.Spacing.LargeSpace
    }),

    secretContainer: style({
        marginTop: TabStyles.Spacing.MediumSpace
    }),

    secretField: {
        maxWidth: '425px',
        width: '100%',
        marginBottom: '5px'
    },

    secretInfo: {
        paddingTop: 8,
        paddingBottom: 8,
        maxWidth: '425px',
        width: '100%'
    },

    baseUrlContainer: {
        marginTop: TabStyles.Spacing.MediumSpace,
        marginLeft:7
    },

    baseUrlField: {
        maxWidth: '425px',
        width: '100%'
    },

    filterList: {
        border: `1px solid ${TabStyles!.Colors!.L6}`,
        maxHeight: '200px',
    },

    filterListItem: {
        paddingTop: '9px'
    }

} as const;
